/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right-bold-circle-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17 12l-5 5v-3H8v-4h4V7l5 5M2 12A10 10 0 0112 2a10 10 0 0110 10 10 10 0 01-10 10A10 10 0 012 12m2 0a8 8 0 008 8 8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8z"/>'
  }
})
